module.exports = __webpack_public_path__ + "static/media/id.6b254ad7.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/id.svg
// module id = 884
// module chunks = 0